import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, DeckNote } from '../../models';


export interface IDeckNoteService  {
	get(deckId: string, id: string): Promise<DeckNote>;
	page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<DeckNote>>;
	list(deckId: string): Promise<DeckNote[]>;
	save(model: DeckNote): Promise<DeckNote>;
	delete(deckId: string, noteId: string): Promise<any>;
}


@injectable()
export class DeckNoteService implements IDeckNoteService {

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(deckId: string, id: string): Promise<DeckNote> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/notes/${id}`;
		return this.httpClient.get<DeckNote>(url);
	}

	public page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<DeckNote>> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/notes/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<DeckNote>>(url);
	}

	public list(deckId: string): Promise<DeckNote[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/notes/`;
		return this.httpClient.get<DeckNote[]>(url);
	}

	public save(model: DeckNote): Promise<DeckNote> {
		const payload = {
			id: model.id,
			deckId: model.deckId,
			text: model.text,
		};
		let url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${model.deckId}/notes`;
		if (model.id !== null && model.id !== undefined && model.id) {
			url += `/${model.id}`;
			return this.httpClient.put<DeckNote>(url, payload);
		}
		return this.httpClient.post<DeckNote>(url, payload);
	}

	public delete(deckId: string, noteId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/notes/${noteId}`;
		return this.httpClient.delete(url);
	}

}
